let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7glrR")).then(() => parcelRequire('ett2M'));